/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useComponentConfig } from "cms/models/hooks/use-components-config";

const ComponentIcon = (props) => {

    const className = props?.className;
    const type = props?.component; // type=component
    const cls = `simplicity-component-icon ${className}`;
    const componentConfig = useComponentConfig(type);
    const icon = componentConfig?.icon;
    const label = componentConfig?.label;
    
    return (
        <span className={cls} title={label}>
            <img 
                src={icon}
                alt={label}
            />
        </span>
    );
    
};

export { ComponentIcon };
